import React from 'react';
import {
    Stack,
    Text,
    CompactPeoplePicker,
    IconButton,
    Persona,
    PersonaSize,
    PersonaPresence,
    IPersonaProps,
    IBasePickerSuggestionsProps,
} from '@fluentui/react';
import { getTextFromItem } from '../utils/helpers';
import { selectedItemListStyles, selectedItemStyles } from '../utils/styles';

interface UserPickerProps {
    onUserResolveSuggestions: (searchText: string) => Promise<IPersonaProps[]> | null;
    onUserSelected: (persona: IPersonaProps) => IPersonaProps | null;
    onRemoveUser: () => void;
    selectedUserPersona?: IPersonaProps;
    suggestionProps: IBasePickerSuggestionsProps;
}

export const UserPicker: React.FC<UserPickerProps> = ({ onUserResolveSuggestions, onUserSelected, onRemoveUser, selectedUserPersona, suggestionProps }) => {
    return (
        <Stack tokens={{ childrenGap: 10 }}>
            <Text variant="medium" styles={{ root: { fontWeight: 600 } }}>
                Select User *
            </Text>
            <CompactPeoplePicker
                styles={{ root: { width: '100%' } }}
                onResolveSuggestions={onUserResolveSuggestions}
                itemLimit={10}
                getTextFromItem={getTextFromItem}
                pickerSuggestionsProps={suggestionProps}
                className={'ms-PeoplePicker'}
                inputProps={{
                    'aria-label': 'User Picker',
                    placeholder: 'Search here to select a user...',
                }}
                resolveDelay={500}
                onItemSelected={onUserSelected}
            />
            {selectedUserPersona && (
                <Stack className={selectedItemListStyles}>
                    <Stack horizontal className={selectedItemStyles}>
                        <Persona
                            imageInitials={selectedUserPersona.imageInitials}
                            text={selectedUserPersona.text}
                            secondaryText={selectedUserPersona.secondaryText}
                            size={PersonaSize.size32}
                            presence={PersonaPresence.none}
                        />
                        <IconButton iconProps={{ iconName: 'Cancel' }} title="Remove user" ariaLabel="Remove user" onClick={onRemoveUser} />
                    </Stack>
                </Stack>
            )}
        </Stack>
    );
};
